/**
 * Sham Cash payment details shown wherever professionals pay the platform
 * (VIP subscription, weekly commission balance). One source of truth so a
 * change to the receiving account updates every payment page.
 */
export const SHAM_CASH_UNIQUE_NUMBER = '7e499ac42d040b016f46a564701f8e96';

/** Account holder name shown by Sham Cash when scanning/transferring. */
export const SHAM_CASH_RECIPIENT_NAME = 'نجاح';

export const SHAM_CASH_QR_LIGHT_URL = 'https://resources.salehli.com/media/sham-qr.png';
export const SHAM_CASH_QR_DARK_URL = 'https://resources.salehli.com/media/sham-qr-white.png';

export const WHATSAPP_CUSTOMER_SERVICE = '963944727793';
